export const formSchema = {
    type: "object",
    properties: {
    //   products: 
    //     {
    //       name: "string",
    //       image: "string",
    //       price: 0,
    //       company: "string",
    //       vatRate: 0,
    //       discount: 0,
    //       netPrice: 0,
    //     grossPrice: 0
    //     }
    // ,
      invoiceNumber: {
        type: "string",
        minLength: 1,
        errorMessage: { minLength: "Date field is required" }
      },
      customerName: {
        type: "string",
        minLength: 1,
        errorMessage: { minLength: "Costumer field is required" }
      },
       totalAmount: {
        type: "string",
        minLength:1,
        errorMessage: { minLength: "Total Amount field is required" }
      },
    },
    required: ["invoiceNumber",'customerName',"totalAmount"],
    additionalProperties: false
  };
  